import { useEffect } from "react";
import { useGlobalContext } from "../../GlobalContextProvider";
import { useGetMerchants } from "../../sdk/tms/merchant/UseGetMerchants";
import { ComponentErrorBoundary } from "../../utilities/ComponentErrorBoundary";

const defaultMerchantNames = ['AMS Test Merchant', 'TMS Test Merchant'];

export default function MerchantSelector(props: {hideHeader?: boolean}) {
    const { merchantId, setMerchantId } = useGlobalContext();
    const { data: Merchants } = useGetMerchants();

    useEffect(() => {
        const defaultMerchant = defaultMerchantNames
            .map((name) => Merchants?.find((merchant) => merchant.name === name))
            .find((merchant) => merchant) ?? Merchants?.at(0);
        setMerchantId(defaultMerchant?.merchantId ?? "");
    }, [Merchants]);

    const onChangeMerchant = (value) => {
        setMerchantId(value);
    }

    return (
        <ComponentErrorBoundary>
          <div
            className="ui form"
            style={{
              marginLeft: 'auto',
              marginRight: '10px',
            }}>
            <div className="field">
              <div className="ui labeled input">
                {props.hideHeader || (<div className="ui label">Merchant</div>)}
                <select onChange={(e) => onChangeMerchant(e.target.value)} value={merchantId}>
                    {Merchants?.map((merchant) => (
                        <option key={merchant.merchantId} value={merchant.merchantId}>
                            {merchant.name}
                        </option>
                    ))}
                </select>
                </div>
              </div>
          </div>
      </ComponentErrorBoundary>
    )
}